require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./unsafely-treat-insecure-origin-as-secure.json") })
        }
      }, "path---unsafely-treat-insecure-origin-as-secure");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---unsafely-treat-insecure-origin-as-secure!./.cache/json/unsafely-treat-insecure-origin-as-secure.json
// module id = 596
// module chunks = 231608221292675